class Routes {

	static async getRoutes(app) {
		let boot_webapp = app.boot_webapp;

		let routes = [];

		// my-bounty routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.bounties || (boot_webapp.routes.bounties.disabled !== true)) {
			const MyBountyRoutes = await import('./mybounty-routes.js');

			const mybountyroutes = MyBountyRoutes.default.getRoutes(app);
	
			if (mybountyroutes) {
				for (var i = 0; i < mybountyroutes.length; i++) {
					routes.push(mybountyroutes[i]);
				}
			}
		}

		// my-deed routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.deeds || (boot_webapp.routes.deeds.disabled !== true)) {
			const MyDeedRoutes = await import('./mydeed-routes.js');

			const mydeedroutes = MyDeedRoutes.default.getRoutes(app);
	
			if (mydeedroutes) {
				for (var i = 0; i < mydeedroutes.length; i++) {
					routes.push(mydeedroutes[i]);
				}
			}
		}

		// my-quotes routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.quotes || (boot_webapp.routes.quotes.disabled !== true)) {
			const MyQuoteRoutes = await import('./myquote-routes.js');

			const myquoteroutes = MyQuoteRoutes.default.getRoutes(app);
	
			if (myquoteroutes) {
				for (var i = 0; i < myquoteroutes.length; i++) {
					routes.push(myquoteroutes[i]);
				}
			}
		}

		return routes;
	}
}

export default Routes;